// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z1OfR","title":"styles_title__7JKCf"};